import { useLocation, useNavigate } from "react-router-dom";
import BaseButton from "../../../../components/ui/BaseButton";
import BaseCard from "../../../../components/ui/BaseCard";

const SettingsHeader = ({
  onSave,
  isLoading,
  completeProfile,
  isUpdated,
  onCancel,
  isEditable,
  setIsEditable,
  hasData,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <BaseCard
      elevation={0}
      className={`py-4 px-5 rounded-xl shadow-lg ${
        completeProfile ? "bg-transparent" : "bg-white"
      }`}
    >
      <div className="flex justify-between w-full">
        <div className="hidden sm:block w-2/6"></div>

        <div className="sm:col-span-4 col-span-7 flex items-center justify-end gap-3">
          {!isEditable && hasData ? (
            <BaseButton
              variant="contained"
              color="primary"
              onClick={() => setIsEditable(true)}
              className="py-[5px] whitespace-nowrap"
            >
              Edit Company Details
            </BaseButton>
          ) : (
            <>
              {isUpdated && (
                <p className="text-amber-600 text-sm font-normal self-center">
                  You have unsaved changes — click Update to apply.
                </p>
              )}
              {hasData && (
                <BaseButton
                  variant="contained"
                  color="primary"
                  onClick={onCancel}
                  className="py-[5px]"
                >
                  Cancel
                </BaseButton>
              )}
              <BaseButton
                loaderSize="24px"
                isLoading={isLoading}
                disabled={isLoading || !isUpdated}
                variant="contained"
                color="primary"
                onClick={onSave}
                className="py-[5px]"
              >
                Update
              </BaseButton>
            </>
          )}
        </div>
      </div>
    </BaseCard>
  );
};

export default SettingsHeader;
